import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getRegisterTokenApi } from "../../services/authApi";
import { checkErrorMessage } from "../../utils/responseHandler";
import "./AuthPage.css";

const GoogleOAuthHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const rtoken = searchParams.get("rtoken");

    if (!rtoken) {
      setStatus("error");
      setMessage("خطا: توکن بازگشتی یافت نشد");
      setTimeout(() => navigate("/"), 3000);
      return;
    }

    if (rtoken === "notregisteredbefore") {
      setStatus("warning");
      setMessage("شما هنوز ثبت نام نکرده‌اید. لطفاً ابتدا ثبت نام کنید.");
      setTimeout(() => navigate("/"), 3000);
      return;
    }

    if (rtoken === "alreadyregistered") {
      setStatus("warning");
      setMessage("شما قبلاً ثبت نام کرده‌اید. لطفاً وارد شوید.");
      setTimeout(() => navigate("/"), 3000);
      return;
    }

    setStatus("processing");
    setMessage("در حال ورود...");

    getRegisterTokenApi(rtoken)
      .then((response) => {
        if (response.data?.success) {
          setStatus("success");
          setMessage("ورود موفقیت‌آمیز");
          setTimeout(() => window.location.reload(), 1000);
        } else {
          setStatus("error");
          setMessage(response.data?.message || "خطا در دریافت توکن");
          setTimeout(() => navigate("/"), 3000);
        }
      })
      .catch((error) => {
        const errorDetails = checkErrorMessage(error);
        setStatus("error");
        setMessage(errorDetails.message || "خطا در دریافت توکن");
        setTimeout(() => navigate("/"), 3000);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1 className="auth-title">🎬 ویدیو پلیر</h1>
        <div style={{ textAlign: "center", padding: "2rem 0" }}>
          {status === "processing" && (
            <div>
              <div className="loading-spinner" style={{ margin: "0 auto 1rem", width: 40, height: 40 }}></div>
              <p style={{ color: "#8a9bb5" }}>{message}</p>
            </div>
          )}
          {status === "warning" && (
            <div>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
              <p style={{ color: "#e67e22" }}>{message}</p>
            </div>
          )}
          {status === "success" && (
            <div>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✅</div>
              <p style={{ color: "#22c55e" }}>{message}</p>
            </div>
          )}
          {status === "error" && (
            <div>
              <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>❌</div>
              <p style={{ color: "#ef4444" }}>{message}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GoogleOAuthHandler;
